import {API} from '../../networking/http'

export type PhoneCheckParams = {
  phone: string
  email?: string
}

export type PhoneCheckReturnType = {
  status: boolean
}

export const checkPhoneApi = (data: PhoneCheckParams) =>
  API.post<PhoneCheckParams, PhoneCheckReturnType>('user/phone-email-check', data).then((res) => res.data)

export const sendOtpApi = (data: { phone: string }) =>
  API.post<{ phone: string }, { status: boolean }>('user/phone-email-send', data).then((res) => res.data)

export const verifyOtpApi = (data: { phone: string, otp: string }) =>
  API.post<{ phone: string, otp: string }, { status: boolean }>('user/phone-email-verify', data).then((res) => res.data)

export type PhoneConflictCheckParams = {
  phone: string
}

export type PhoneConflictCheckReturnType = {
  available: boolean
}

export const checkPhoneConflictApi = (data: PhoneConflictCheckParams) =>
  API.post<PhoneConflictCheckParams, PhoneConflictCheckReturnType>('users/checkPhoneConflict', data).then((res) => res.data)

export const updatePhoneApi = (data: { phone: string }) =>
  API.post<{ phone: string }, { success: boolean, phone: string }>('users/updatePhone', data).then((res) => res.data)

export const checkPhoneForChangeApi = (data: { phone: string }) =>
  API.post<{ phone: string }, { available: boolean }>('users/checkPhoneForChange', data).then((res) => res.data)

export const changePhoneApi = (idToken: string, originalToken?: string) =>
  API.post<{ idToken: string }, { success: boolean, token?: string }>(
    'users/changePhone',
    {idToken},
    originalToken ? {
      headers: {
        Authorization: `Bearer ${originalToken}`,
      },
    } : {},
  ).then((res) => res.data)
